export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';

export interface SetItemAction<T = unknown> {
  type: typeof ADD_ITEM;
  name: string;
  data: T;
}

export interface RemoveItemAction {
  type: typeof REMOVE_ITEM;
  name: string;
}

export type ItemsAction = SetItemAction | RemoveItemAction;

export function setItem<T>(name: string, data: T): SetItemAction<T> {
  return {
    type: ADD_ITEM,
    name,
    data,
  };
}

export function removeItem(name: string): RemoveItemAction {
  return {
    type: REMOVE_ITEM,
    name,
  };
}
